import { render, staticRenderFns } from "./Link3ds.vue?vue&type=template&id=0163b61b&scoped=true&"
import script from "./Link3ds.vue?vue&type=script&lang=js&"
export * from "./Link3ds.vue?vue&type=script&lang=js&"
import style0 from "./Link3ds.vue?vue&type=style&index=0&id=0163b61b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163b61b",
  null
  
)

export default component.exports